import { IParamsNotification, IResponseGetNotification } from '~/utils/interface/notification';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

const notificationApi = {
  getNotifications(params: IParamsNotification) {
    const url = `api/admin/notifications`;
    return axiosClient.get<IApiBaseResponse<IResponseGetNotification>>(url, { params });
  },

  updateNotifications() {
    const url = `api/admin/notifications`;
    return axiosClient.put<IApiBaseResponse<IResponseGetNotification>>(url);
  },
};

export default notificationApi;
